module.exports = __webpack_public_path__ + "static/media/icon_twitter.b73a8618.svg";